export enum ESubdomain {
  SEM_PARAR = 'sempararempresas',
  CARGILL = 'cargill',
  TORQI = 'torqi', // ? On staging it will be homologation.torqi.com.br, this is just for production
}

export const getSubdomain = (): ESubdomain | null => {
  const host = window.location.hostname;
  const parts = host.split('.');

  if (host.includes('localhost')) {
    return ESubdomain.TORQI; // ? Assume torqi for localhost, since it's only used for development
  }

  if (parts.length > 2) {
    return parts[0] as ESubdomain;
  }

  return null;
};
